// Experiment name: "test_step1_upsell_copy_desktop" and "exp-test_step1_upsell_copy_mw" - clean up ticket: EVT-35329
export const isInMwStep1UpsellABTest = () =>
  evite.experiments.inVariation('test_step1_upsell_copy_mw', 'variant', false);

export const isInDesktopStep1UpsellABTest = () =>
  evite.experiments.inVariation('test_step1_upsell_copy_desktop', 'variant', false);
